/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation IpDirectoryDeleteMutation($ipDirectoryId: ID!) {
  IpDirectoryDelete(ipDirectoryId: $ipDirectoryId) {
    id
    message
    status
  }
}
`
